import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimProcessingType extends IModelBase {
  Name: string
  Value: string
}

@Injectable()
export class ClaimProcessingTypeODataService extends ODataService<IClaimProcessingType> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimProcessingTypes'
  }
}
